/**
 * Account signup
 */

(function($, extra) {

    $(document).ready(function() {

        /***** ELEMENTS *****/

        var $form = $('form.signup'),
            $global_error = $form.find('.js-global-error'),
            $first_name = $form.find('input#id_first_name'),
            $last_name = $form.find('input#id_last_name'),
            $date_of_birth_day = $form.find('input#id_date_of_birth_day'),
            $date_of_birth_month = $form.find('input#id_date_of_birth_month'),
            $date_of_birth_year = $form.find('input#id_date_of_birth_year'),
            $gender = $form.find('.js-gender input'),
            $nationality = $form.find('select#id_nationality'),
            $email = $form.find('input#id_email'),
            $password1 = $form.find('input#id_password1'),
            $password2 = $form.find('input#id_password2'),
            $submit_button = $form.find('.js-submit-button'),

            email_regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
            email_invalid_usernames = [
                'abuse',
                'admin',
                'billing',
                'compliance',
                'devnull',
                'dns',
                'ftp',
                'hostmaster',
                'inoc',
                'ispfeedback',
                'ispsupport',
                'list-request',
                'list',
                'maildaemon',
                'noc',
                'no-reply',
                'noreply',
                'null',
                'phish',
                'phishing',
                'postmaster',
                'privacy',
                'registrar',
                'root',
                'security',
                'spam',
                'support',
                'sysadmin',
                'tech',
                'undisclosed-recipients',
                'unsubscribe',
                'usenet',
                'uucp',
                'webmaster',
                'www'
            ];

        /***** UTILITIES *****/

        function set_error($field, message) {
            $field
                .closest('.js-form-row')
                .find('.js-errors')
                .html('<ul class="errorlist"><li>' +  message + '</li></ul>')
                .show();
        }

        function clear_error($field) {
            $field
                .closest('.js-form-row')
                .find('.js-errors')
                .html('')
                .hide();
        }

        function scroll_to($element) {
            $('html, body').animate({
                scrollTop: ($element.offset().top - 50)
            }, 500);
        }

        /***** VALIDATORS *****/

        function validate_completed($field, no_error) {
            // validate a text/select field has a value
            var val = ($field.val() || '').trim();
            if (!val) {
                if (!no_error) {
                    set_error($field, extra.error_required);
                }
                return false;
            }
            return true;
        }

        function validate_checked($field, no_error) {
            // validate a checkbox/radio field is checked
            if (!$field.is(':checked')) {
                if (!no_error) {
                    set_error($field, extra.error_required);
                }
                return false;
            }
            return true;
        }

        function validate_date_of_birth() {
            // check the date entered is a valid date and 15 <= age <= 110
            var day = ($date_of_birth_day.val() || ''),
                month = ($date_of_birth_month.val() || ''),
                year = ($date_of_birth_year.val() || ''),
                date,
                today,
                m,
                age;

            if (!day || !month || !year) {
                set_error($date_of_birth_day, extra.error_required);
                return false;
            }

            day = parseInt(day);
            month = parseInt(month);
            year = parseInt(year);
            if (isNaN(day) || isNaN(month) || isNaN(year)) {
                set_error($date_of_birth_day, extra.error_date_of_birth_invalid);
                return false;
            }

            if (day < 1 || day > 31) {
                // day not 1-31
                set_error($date_of_birth_day, extra.error_date_of_birth_invalid);
                return false;
            }

            month--;    // note: JS months are zero-indexed
            if (m < 0 || month > 11) {
                // month not 1-12
                set_error($date_of_birth_day, extra.error_date_of_birth_invalid);
                return false;
            }

            today = new Date();
            if (year < 1900 || year > today.getFullYear()) {
                // date out of normal range
                set_error($date_of_birth_day, extra.error_date_of_birth_invalid);
                return false;
            }

            date = new Date(year, month, day);
            if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
                // invalid, e.g. 31st Feb
                set_error($date_of_birth_day, extra.error_date_of_birth_invalid);
                return false;
            }

            today = new Date();
            age = today.getFullYear() - date.getFullYear();
            m = today.getMonth() - date.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
                age--;
            }
            if (age < 15 || age > 110) {
                set_error($date_of_birth_day, extra.error_date_of_birth_age);
                return false;
            }

            return true;
        }

        function validate_email_syntax($field, no_error) {
            // validate an email is a valid email
            if (!validate_completed($field, true)) {
                return false;
            }
            var email = ($field.val() || '').trim();
            if (!email_regex.test(email)) {
                if (!no_error) {
                    set_error($email, extra.error_email_syntax);
                }
                return false;
            }
            return true;
        }

        function validate_password_matches() {
            // validate that two fields values match (assuming both are completed)
            var val1 = ($password1.val() || '').trim(),
                val2 = ($password2.val() || '').trim();
            if (!val1 || !val2) {
                // should be handled by validate_completed() above
                return false;
            }
            if (val1 !== val2) {
                set_error($password2, extra.error_password_mismatch);
                return false;
            }
            return true;
        }

        function validate_email_username($field, no_error) {
            // check that the email is "allowed", i.e. not containing certain black-listed terms
            if (!validate_email_syntax($field, true)) {
                return false;
            }
            var email = ($field.val() || '').trim(),
                username = email.substring(0, email.indexOf('@'));
            if (email_invalid_usernames.includes(username)) {
                if (!no_error) {
                    set_error($field, extra.error_email_username);
                }
                return false;
            }
            return true;
        }

        /***** HANDLERS *****/

        $form.on('submit', function(e) {
            var first_name_valid,
                last_name_valid,
                date_of_birth_valid,
                gender_valid,
                nationality_valid,
                email_valid,
                password_valid;

            $global_error.hide();
            $submit_button.prop('disabled', true).css('opacity', 0.5);

            clear_error($first_name);
            first_name_valid = validate_completed($first_name);

            clear_error($last_name);
            last_name_valid = validate_completed($last_name);

            clear_error($date_of_birth_day);
            date_of_birth_valid = validate_date_of_birth();

            clear_error($gender);
            gender_valid = validate_checked($gender);

            clear_error($nationality);
            nationality_valid = validate_completed($nationality);

            clear_error($password1);
            clear_error($password2);
            password_valid = validate_completed($password1);
            password_valid = validate_completed($password2) && password_valid;
            password_valid = password_valid && validate_password_matches();

            clear_error($email);
            email_valid = validate_completed($email);
            email_valid = email_valid && validate_email_syntax($email);
            email_valid = email_valid && validate_email_username($email);

            if (
                !first_name_valid ||
                !last_name_valid ||
                !date_of_birth_valid ||
                !gender_valid ||
                !nationality_valid ||
                !email_valid ||
                !password_valid
            ) {
                $global_error.show();
                scroll_to($global_error);
                $submit_button.prop('disabled', false).css('opacity', 1.0);
                e.preventDefault();
                return false;
            }

            return true;
        });

    });
})(window.jQuery, window.__extra);
